import { uid } from "@xbs/lib-state";
import { createProject } from "../../../actions/project";
import { getCountLabel } from "../../../common/text";
export default function (store, { action, id, locale }) {
    if (!action) {
        return;
    }
    const { projects, menuState } = store.getState();
    const actions = action.split(":");
    const rootAction = actions.at(0);
    const menuAction = actions.at(1);
    switch (rootAction) {
        case "sort":
            sortActionHandler(store, menuAction);
            break;
        case "completed":
            completedActionHandler(store, menuAction);
            break;
        case "add":
            createProject(store, {
                id: "temp://" + uid(),
                label: getCountLabel("New project", projects, locale),
            });
            break;
        case "rename":
            store.in.exec("open-inline-editor", {
                id,
                type: "project",
            });
            break;
        case "delete":
            store.in.exec("delete-project", {
                id,
            });
            break;
    }
    store.in.exec("close-menu", { ...menuState });
}
function completedActionHandler(store, action) {
    switch (action) {
        case "show":
            store.in.exec("show-completed-tasks", {});
            break;
        case "hide":
            store.in.exec("hide-completed-tasks", {});
            break;
    }
}
function sortActionHandler(store, action) {
    switch (action) {
        case "text-asc":
            store.in.exec("set-sort", {
                by: "text",
                dir: "asc",
                tree: true,
            });
            break;
        case "text-desc":
            store.in.exec("set-sort", {
                by: "text",
                dir: "desc",
                tree: true,
            });
            break;
        case "due-date-asc":
            store.in.exec("set-sort", {
                by: "due_date",
                dir: "asc",
                tree: true,
            });
            break;
        case "due-date-desc":
            store.in.exec("set-sort", {
                by: "due_date",
                dir: "desc",
                tree: true,
            });
            break;
        case "completion-date-asc":
            store.in.exec("set-sort", {
                by: "completion_date",
                dir: "asc",
                tree: true,
            });
            break;
        case "completion-date-desc":
            store.in.exec("set-sort", {
                by: "completion_date",
                dir: "desc",
                tree: true,
            });
            break;
        case "created-date-asc":
            store.in.exec("set-sort", {
                by: "creation_date",
                dir: "asc",
                tree: true,
            });
            break;
        case "created-date-desc":
            store.in.exec("set-sort", {
                by: "creation_date",
                dir: "desc",
                tree: true,
            });
            break;
        case "edited-date-asc":
            store.in.exec("set-sort", {
                by: "edited_date",
                dir: "asc",
                tree: true,
            });
            break;
        case "edited-date-desc":
            store.in.exec("set-sort", {
                by: "edited_date",
                dir: "desc",
                tree: true,
            });
            break;
        case "priority-asc":
            store.in.exec("set-sort", {
                by: "priority",
                dir: "asc",
                tree: true,
            });
            break;
        case "priority-desc":
            store.in.exec("set-sort", {
                by: "priority",
                dir: "desc",
                tree: true,
            });
            break;
    }
}
//# sourceMappingURL=toolbar.js.map